import { defineStore } from "pinia";
import { useState } from "@erp/shared/composables";
import { processSteps } from "../ProjectPage.const";
export const useClickedProcessStore = defineStore("useClickedProcessStore", () => {
    const [clickedProcess, setClickedProcess] = useState(processSteps[0]);
    return {
        clickedProcess,
        setClickedProcess,
    };
});
